var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"lazy-container",rawName:"v-lazy-container",value:({ selector: 'img'}),expression:"{ selector: 'img'}"}],staticClass:"img-loader"},[_c('img',{attrs:{"data-src":_vm.src,"alt":_vm.alt}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab833556","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ImageLoader.vue
// module id = FQYj
// module chunks = 0